// extracted by mini-css-extract-plugin
module.exports = {"root":"Input_root__2Czvo","root_standart":"Input_root_standart__1732u","root_fullWidth":"Input_root_fullWidth__3o_TD","root_error":"Input_root_error__3VU4l"};